module.exports = __webpack_public_path__ + "static/img/shareicon.2addd71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shareicon.png
// module id = FW2X
// module chunks = 24